<template>
  <v-app data-lpus-register-app>
    <LpusRegisterContent />
    <component
      :is="BaseDialog"
      v-if="BaseDialog"
    />
  </v-app>
</template>

<script lang="ts" setup>
import LpusRegisterContent from 'src/components/pages/profile/lpus/register/index/LpusRegisterContent/LpusRegisterContent.vue'
import { onMounted, shallowRef } from 'vue'

const BaseDialog = shallowRef<any>()

onMounted(async () => {
  if (typeof document !== 'undefined') {
    // TODO: заменить на версию для серверного рендера
    BaseDialog.value = (await import(/* webpackMode: 'eager' */'www/vue_components/common/core/BaseDialog/BaseDialog.vue')).default
  }
})
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/mixins';

#data-lpus-register-app {
  @include v-app-reset;
}
</style>
